// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* (mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/
mat-card {
  margin: 6px;
  padding: 6px;
}

.buttons {
  margin: 5px;
  /* mat-dialog-actions */
}
.buttons button {
  margin-left: 6px;
}
.buttons button:first-child {
  margin-left: 0;
}

.mat-mdc-card-image {
  cursor: pointer;
}

.grid-header {
  font-weight: bold;
}

.vehicle-content {
  flex-wrap: wrap;
  box-sizing: border-box;
  display: flex;
}

:host ::ng-deep .right-most .container .content-editor .ql-container.ql-snow {
  resize: vertical;
  overflow-y: scroll !important;
  max-height: 25em !important;
}
:host ::ng-deep .right-most .container .content-editor .ql-container.ql-snow table {
  width: 100%;
  border-radius: 5em;
  border-color: black;
}
:host ::ng-deep .right-most .container .content-editor .ql-container.ql-snow table tr {
  outline: thin solid;
  border-color: black;
}
:host ::ng-deep .right-most .container .content-editor .ql-container.ql-snow table td {
  outline: thin solid;
  border-color: black;
}
:host ::ng-deep .right-most .container .content-editor .ql-container.ql-snow table tr:last-child td {
  border-bottom: 0 solid;
}

.left-most {
  flex: 1;
}

.second-left-most {
  flex: 1;
}

.right-most {
  flex: 2;
}

b {
  margin-left: 6px;
}

.vehicle-content mat-grid-tile ::ng-deep.grid-header .mat-figure {
  justify-content: flex-start;
  padding-right: 1ex;
}
.vehicle-content mat-grid-tile ::ng-deep .mat-figure {
  justify-content: flex-start;
}

:host > div {
  margin-bottom: 0;
}
:host > div.vehicle-definition {
  margin-bottom: 0;
}
:host > div.vehicle-definition .grid-header {
  font-size: 16px;
}

/* handles window changing x-size */
.vehicle-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

@media (max-width: 1300px) {
  .vehicle-content {
    grid-template-columns: 1fr 1fr;
  }
}
.right-most {
  grid-column: span 2;
}

.mat-mdc-cell {
  padding: 0 1em 0 1em;
}

.footer-spacing {
  display: block;
  height: 50vh;
  width: 100%;
  background-image: linear-gradient(to bottom, transparent, #bbb);
}

.table-title {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.table-title b {
  margin-left: 6px;
  grid-column: span 3;
  align-self: center;
}
.table-title button {
  grid-column: span 1;
}

.attachments mat-grid-tile ::ng-deep.grid-header .mat-figure {
  justify-content: flex-start;
  padding-right: 1ex;
}
.attachments mat-grid-tile ::ng-deep .mat-figure {
  justify-content: flex-start;
}

.mat-mdc-card-image {
  object-fit: contain;
  width: 100%;
  height: 90%;
  margin: 0;
}

.center-text {
  text-align: center;
}

.version-button {
  max-width: 400px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/vehicle/vehicle.component.scss"],"names":[],"mappings":"AAAA,sHAAA;AACA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EAEA,uBAAA;AAAF;AACE;EACE,gBAAA;AACJ;AAAI;EACE,cAAA;AAEN;;AAGA;EACE,eAAA;AAAF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,6BAAA;EACA,2BAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AAEE;EACE,mBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,mBAAA;AADJ;AAIE;EACE,sBAAA;AAFJ;;AAMA;EACE,OAAA;AAHF;;AAKA;EACE,OAAA;AAFF;;AAIA;EACE,OAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAKE;EACE,2BAAA;EACA,kBAAA;AAFJ;AAIE;EACE,2BAAA;AAFJ;;AAMA;EACE,gBAAA;AAHF;AAKE;EACE,gBAAA;AAHJ;AAII;EACE,eAAA;AAFN;;AAOA,mCAAA;AACA;EACE,aAAA;EACA,qCAAA;AAJF;;AAMA;EACE;IACE,8BAAA;EAHF;AACF;AAKA;EACE,mBAAA;AAHF;;AAMA;EACE,oBAAA;AAHF;;AAMA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EAEA,+DAAA;AAJF;;AAWA;EACE,aAAA;EACA,qCAAA;AARF;AASE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAPJ;AASE;EACE,mBAAA;AAPJ;;AAYE;EACE,2BAAA;EACA,kBAAA;AATJ;AAWE;EACE,2BAAA;AATJ;;AAaA;EACE,mBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AAVF;;AAYA;EACE,kBAAA;AATF;;AAWA;EACE,gBAAA;AARF;AACA,4oKAA4oK","sourcesContent":["/* (mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/\nmat-card {\n  margin: 6px;\n  padding: 6px;\n}\n\n.buttons {\n  margin: 5px;\n  // height: 36px;\n  /* mat-dialog-actions */\n  button {\n    margin-left: 6px;\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n}\n\n.mat-mdc-card-image {\n  cursor: pointer;\n}\n.grid-header {\n  font-weight: bold;\n}\n\n.vehicle-content {\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  display: flex;\n}\n\n:host ::ng-deep .right-most .container .content-editor .ql-container.ql-snow {\n  resize: vertical;\n  overflow-y: scroll !important;\n  max-height: 25em !important;\n\n  table {\n    width: 100%;\n    border-radius: 5em;\n    border-color: black;\n  }\n\n  table tr {\n    outline: thin solid;\n    border-color: black;\n  }\n\n  table td {\n    outline: thin solid;\n    border-color: black;\n  }\n\n  table tr:last-child td /*To remove the last border*/ {\n    border-bottom: 0 solid;\n  }\n}\n\n.left-most {\n  flex: 1;\n}\n.second-left-most {\n  flex: 1;\n}\n.right-most {\n  flex: 2;\n}\n\nb {\n  margin-left: 6px;\n}\n\n.vehicle-content mat-grid-tile ::ng-deep {\n  &.grid-header .mat-figure {\n    justify-content: flex-start;\n    padding-right: 1ex;\n  }\n  .mat-figure {\n    justify-content: flex-start;\n  }\n}\n\n:host > div {\n  margin-bottom: 0;\n\n  &.vehicle-definition {\n    margin-bottom: 0;\n    .grid-header {\n      font-size: 16px;\n    }\n  }\n}\n\n/* handles window changing x-size */\n.vehicle-content {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n}\n@media (max-width: 1300px) {\n  .vehicle-content {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n.right-most {\n  grid-column: span 2;\n}\n\n.mat-mdc-cell {\n  padding: 0 1em 0 1em;\n}\n\n.footer-spacing {\n  display: block;\n  height: 50vh;\n  width: 100%;\n\n  background-image: linear-gradient(to bottom, transparent, #bbb);\n  // background-image: none;\n  // background-color: #f1f1f1; __<<ngThemingMigrationEscapedComment2>>__\n  // background-color: #dee1e6; __<<ngThemingMigrationEscapedComment3>>__\n  // background-image: linear-gradient( to right, #dee1e6, #f1f1f1 );\n}\n\n.table-title {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  b {\n    margin-left: 6px;\n    grid-column: span 3;\n    align-self: center;\n  }\n  button {\n    grid-column: span 1;\n  }\n}\n\n.attachments mat-grid-tile ::ng-deep {\n  &.grid-header .mat-figure {\n    justify-content: flex-start;\n    padding-right: 1ex;\n  }\n  .mat-figure {\n    justify-content: flex-start;\n  }\n}\n\n.mat-mdc-card-image {\n  object-fit: contain;\n  width: 100%;\n  height: 90%;\n  margin: 0;\n}\n.center-text {\n  text-align: center;\n}\n.version-button {\n  max-width: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
